<template>
    <div class="empezar-licitar-buttons">
        <cta-button
            link="/registrarse"
            class="empezar-licitar-buttons-register"
            level="success"
            :text="$t($root.lenguaje_pais+'.registro.texto_general', { dias: $root.currentTrialDays })"
            :hiddentext="$t($root.lenguaje_pais+'.registro.texto_hidden', { dias: $root.currentTrialDays })"
            :breakpoints="[{ window: 410, text: $t($root.lenguaje_pais+'.registro.texto_breakpoint', { dias: $root.currentTrialDays }), hiddentext: $t($root.lenguaje_pais+'.registro.texto_breakpoint', { dias: $root.currentTrialDays }) }]">
        </cta-button>
        <cta-button
            link="/contacto"
            class="empezar-licitar-buttons-register-contact"
            level="info"
            text="Habla con un consultor"
            hiddentext="Resolver dudas ahora">
        </cta-button>
    </div>
</template>

<script>
export default {
    name: 'BannerLicitar',    
    data: () => ({
    })
}
</script>